import { buildingsComparisonReducer } from './buildings-comparison/buildings-comparison.reducer';
import { initialState, type State } from './pages.state';

export function pagesReducer(state: State = initialState, action: any): State {
    return {
        buildingsComparison: buildingsComparisonReducer(state.buildingsComparison, action)
    };
}
